'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _getPurchasedProducts = require('ifeis-isomorphic/lib/redux/actions/products/getPurchasedProducts');

var purchasedProducts = _interopRequireWildcard(_getPurchasedProducts);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductsAccountsController = function () {
  function ProductsAccountsController(feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, ProductsAccountsController);

    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this.headers = ['Account Owner/Dancer Names', 'Competitor #', 'Product', 'Quantity', 'Balance Due'];
    this.isLoading = true;

    $ngRedux.dispatch(purchasedProducts.getPurchasedProducts(feis.id)).then(function (productsResponse) {
      _this.purchasedProducts = productsResponse.payload.reduce(function (accum, product) {
        if (accum[product.accountId]) {
          var dancersArray = accum[product.accountId].dancersArray;
          var dancer = {
            dancerName: product.person.fname + ' ' + product.person.lname,
            competitorNumber: product.reg
          };
          dancersArray.push(dancer);
          accum[product.accountId].dancersArray = dancersArray;
          return accum;
        } else {
          accum[product.accountId] = {
            accountName: product.acct_fname + ' ' + product.acct_lname,
            accountBalance: product.balance,
            dancersArray: [],
            productsArray: product.productsArray || []
          };
          return accum;
        }
      }, {}) || {};
    }).catch(function (error) {
      return _this.msgService.displayErrorMsg(error.message || error.toString());
    }).finally(function () {
      return _this.isLoading = false;
    });
  }

  _createClass(ProductsAccountsController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var _this2 = this;

      var csv = [];
      csv.push(this.headers);
      Object.keys(this.purchasedProducts).forEach(function (accountId) {
        csv.push([_this2.purchasedProducts[accountId].accountName || '', '', '', '', (_this2.purchasedProducts[accountId].accountBalance || 0).toFixed() || '']);
        _this2.purchasedProducts[accountId].dancersArray.forEach(function (dancer) {
          csv.push([dancer.dancerName || '', dancer.competitorNumber || '']);
        });
        _this2.purchasedProducts[accountId].productsArray.forEach(function (product) {
          csv.push(['', '', product.description || product.name || '', product.purchased || '']);
        });
      });

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Product_by_account.csv');
    }
  }]);

  return ProductsAccountsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.products-by-account', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.products-by-account', {
    url: '/products-by-account',
    template: require('./tpl.html'),
    controller: ProductsAccountsController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/products-by-account/index.js
// module id = 565
// module chunks = 0